import { DataTable } from 'primereact/datatable'
import React from 'react'
import PrimeTableFooter from '../../../components/PrimeTableFooter'
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import NoInfo from '../../../components/NoInfo';
import NumberUtil from '../../../utility/NumberUtil';

const DataQualityTable = ({rows,editItem}) => {

    const { t } = useTranslation();

    const ratingCount1 = (rowData)=>{
       // 判斷這些欄位是不是有效（不是 0、不是 "0"、不是 null/undefined/''）
      const isValid = (val) => val !== undefined && val !== null && val !== '' && val !== 0 && val !== '0';
      const rat1 = isValid(rowData?.dataReliability);
      const rat2 = isValid(rowData?.dataIntegrity);
      const rat3 = isValid(rowData?.dataTimeliness);
      const rat4 = isValid(rowData?.dataLocation);
      const rat5 = isValid(rowData?.dataTechnical);
        // 計算有多少個 false
      let falseCount = [rat1, rat2, rat3, rat4, rat5].filter(rating => rating === false).length;

        // 如果有 false，返回 "非false數量/5 未完成"
        if (falseCount > 0) {
            return `${t('inProgress')} (${5 - falseCount}/5) `;
        }

        // 如果沒有 false，返回 "已完成"
        return t('completed');
    }

    const ratingCount2 = (rowData)=>{
        // 判斷這些欄位是不是有效（不是 0、不是 "0"、不是 null/undefined/''）
        const isValid = (val) => val !== undefined && val !== null && val !== '' && val !== 0 && val !== '0';
        const rat1 = isValid(rowData?.coefReliability);
        const rat2 = isValid(rowData?.coefIntegrity);
        const rat3 = isValid(rowData?.coefTimeliness);
        const rat4 = isValid(rowData?.coefLocation);
        const rat5 = isValid(rowData?.coefTechnical);
         // 計算有多少個 false
        let falseCount = [rat1, rat2, rat3, rat4, rat5].filter(rating => rating === false).length;

        // 如果有 false，返回 "非false數量/5 未完成"
        if (falseCount > 0) {
            return `${t('inProgress')} (${5 - falseCount}/5) `;
        }

        // 如果沒有 false，返回 "已完成"
        return t('completed');
    }

    const actionBodyTemplate = (rowData)=>{
      if(rowData){
      return(
          <>
          <Button
              rounded text severity="secondary"
              className="p-button-icon-only"
              tooltip={t('button.detail')}
              onClick={()=>{editItem(rowData)}}
          >
              <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          </>
          )
      }
  }

  return (
    <DataTable 
            stripedRows
            value={rows} 
            className="white-data-table hover-highlight no-shadow mt-1"
            tableStyle={{ minWidth: '50rem' }}
            footer={rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false}  />}
            emptyMessage={<NoInfo panel="table" size="md" />}
        >
            <Column style={{width:'150px'}} field="stageName" header={t('lifeCycleStage')}></Column>
            <Column style={{width:'250px'}} field="dataName" header={t('activityDataName')}></Column>
            <Column style={{width:'150px', textAlign:'right'}} headerStyle={{textAlign:'right'}} headerClassName="right-header" body={(rowData,props)=>{
                return (
                <>
                    <div>{NumberUtil.formatWithCommas(rowData?.unitQuantity)}</div>
                    <div>{rowData?.dataUnitName}</div>
                </>)
            }} field="unitQuantity" header={<>{t('quantityPerUnit')}<br/>({t('unit')})</>}></Column>
            <Column style={{width:'150px'}} body={ratingCount1} field="dataQuality" header={t('activity_data')}></Column>
            <Column style={{width:'150px'}} body={ratingCount2} field="emissionCoefficient" header={t('emissionFactor')}></Column>
            <Column style={{width:'100px'}} header={t('action')} body={actionBodyTemplate}></Column>
        </DataTable>
  )
}

export default DataQualityTable